import { useEffect, useMemo, useState } from 'react';
import { shippingApi } from '../services/subscriberApi.js';
import { pakistanCities } from '../data/pakistanCities';

/**
 * Leopards destination cities from DB (via /shipping/cities).
 * Falls back to static pakistanCities only if API is empty.
 */
export default function useCourierCities() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = async () => {
    setLoading(true);
    setError('');
    try {
      const r = await shippingApi.getCities();
      const list = Array.isArray(r?.data?.cities) ? r.data.cities : [];
      setCities(list);
      if (list.length === 0) {
        setError(r?.data?.message || 'Courier cities not imported yet.');
      }
    } catch (e) {
      setCities([]);
      setError(e?.response?.data?.message || e?.message || 'Could not load cities.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  const names = useMemo(() => {
    if (cities.length > 0) {
      return cities.map((c) => c.name).filter(Boolean);
    }
    return pakistanCities;
  }, [cities]);

  return {
    cities,
    names,
    loading,
    error,
    reload,
    fromDatabase: cities.length > 0,
  };
}
